// extracted by mini-css-extract-plugin
module.exports = {"actionDropDown":"ProjectList_actionDropDown_2qCAR","overdue":"ProjectList_overdue_2yjDr","spinAround":"ProjectList_spinAround_1OcVc"};